import { render, staticRenderFns } from "./SpeceficInners.vue?vue&type=template&id=de95b7ec&scoped=true"
import script from "./SpeceficInners.vue?vue&type=script&lang=js"
export * from "./SpeceficInners.vue?vue&type=script&lang=js"
import style0 from "./SpeceficInners.vue?vue&type=style&index=0&id=de95b7ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de95b7ec",
  null
  
)

export default component.exports